var _rect, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIco5Proceso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_5_proceso",
    xmlns: "http://www.w3.org/2000/svg",
    width: 190,
    height: 190,
    viewBox: "0 0 190 190",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6460",
    "data-name": "Rectangle 6460",
    width: 190,
    height: 190,
    transform: "translate(0)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8392",
    "data-name": "Group 8392",
    transform: "translate(55.961 20.796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8391",
    "data-name": "Group 8391",
    transform: "translate(8.628 4.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20418",
    "data-name": "Path 20418",
    d: "M180.316,275.521v-1.855a5.264,5.264,0,0,0-4.231-5.154,7.734,7.734,0,0,0-7.643-6.643H126.613a7.734,7.734,0,0,0-7.643,6.643,5.264,5.264,0,0,0-4.231,5.154v1.855A5.23,5.23,0,0,0,116,278.928l4.9,76.36-2.335,26.925h13.8l.186-1.873c.345-3.476,4.874-8.386,11.143-8.386,8.57,0,11.461,4.909,11.806,8.386l.186,1.873h21.359l-1.408-18.276,3.257-86.3C179.677,276.721,180.316,276.821,180.316,275.521Z",
    transform: "translate(-114.739 -261.869)",
    fill: "#8dc6e8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20419",
    "data-name": "Path 20419",
    d: "M159.218,260.764v-2.126a6.034,6.034,0,0,0-4.85-5.908,8.864,8.864,0,0,0-8.76-7.613H97.665a8.865,8.865,0,0,0-8.761,7.613,6.034,6.034,0,0,0-4.85,5.908v2.126a5.994,5.994,0,0,0,1.445,3.9l2.935,87.526-2.677,30.86H113.7l.213-2.147a7.767,7.767,0,0,1,15.456,0l.213,2.147h27.937l-2.677-30.86,2.935-87.526A6,6,0,0,0,159.218,260.764ZM123.09,350.828h-2.906v-6.444a1.453,1.453,0,1,1,2.906,0Zm.426,4.764-.835,4.384h-2.089l-.835-4.384Zm4.338-4.764v-6.444a6.217,6.217,0,1,0-12.433,0v6.444H93.155l-2.817-84.039h62.6l-2.817,84.039Zm-37.773-88.8a1.263,1.263,0,0,1-1.261-1.261v-2.126a1.263,1.263,0,0,1,1.261-1.261h63.113a1.263,1.263,0,0,1,1.261,1.261v2.126a1.263,1.263,0,0,1-1.261,1.261Zm7.585-12.146h47.943a4.1,4.1,0,0,1,3.857,2.733H93.808A4.1,4.1,0,0,1,97.665,249.88ZM133.7,378.291a12.538,12.538,0,0,0-24.135,0H90.953l1.968-22.7h21.986l1.743,9.148h9.972l1.742-9.148h21.987l1.968,22.7Z",
    transform: "translate(-84.055 -245.116)",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20420",
    "data-name": "Path 20420",
    d: "M1298.862,302.374a61.613,61.613,0,0,1,6.472,9.21c1.779,3.3-.477,8.605-5.211,9.366a7.029,7.029,0,0,1-8.35-6.6,4.338,4.338,0,0,1,.31-1.885C1293.6,308.668,1296.257,305.639,1298.862,302.374Zm.232,5.49-.472-.022c-1.06,1.8-2.22,3.56-3.145,5.431-.584,1.183.183,2.814,1.4,3.642a3.566,3.566,0,0,0,4.126-.122,3.111,3.111,0,0,0,1.185-3.707C1301.261,311.291,1300.135,309.6,1299.094,307.864Z",
    transform: "translate(-1205.324 -144.813)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    cx: 89.269,
    cy: 89.269,
    r: 89.269,
    transform: "translate(4.234 5.928)",
    fill: "#fff",
    opacity: 0.23,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco5Proceso);
export default __webpack_public_path__ + "static/media/ico_5_proceso.1fb3e75339ef9002c3c523496b8bc958.svg";
export { ForwardRef as ReactComponent };